// Webpack Imports
import Modal from 'bootstrap/js/dist/modal'

// Import Swiper Js + Navigation module
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

( function () {
	'use strict';

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	// var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	// var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
	// 	return new bootstrap.Popover( popoverTriggerEl, {
	// 		trigger: 'focus',
	// 	});
	// });

	// Initialize Modals: https://getbootstrap.com/docs/5.0/components/modal
	var modalTriggerList = [].slice.call( document.querySelectorAll( '.vv-modal' ) );
	var modalsList = modalTriggerList.map( function ( modalTriggerEl ) {
		var popupModal = new Modal(modalTriggerEl, {
			keyboard: false
		});

		// Set the variables
		var popupID = modalTriggerEl.id;
		var thePopup = document.getElementById(popupID);
		var delay = modalTriggerEl.dataset.delay;
		var exipres = modalTriggerEl.dataset.expire;

		// Check for the cookie
		let popupCookie = getCookie('popup_'+popupID+'');

		// Run the popup
		if( popupCookie != 'shown') {
			setTimeout(function () {
				popupModal.show()
			}, delay);
		}

		// Set the cookie on close
		thePopup.addEventListener('hidden.bs.modal', function (event) {
			setCookie( 'popup_'+popupID+'', 'shown', exipres );
		});
		
	});

	// [].forEach.call(modalsList, function( modal, index, arr ) {
		
	// });

	// Fixed Header
	var header = document.getElementById('header');
	var headerPh = document.querySelector('.vv-fixed-header-holder');
	var topBar = document.getElementById('topbar');
	var topBarHeight = topBar.offsetHeight;
	var headerHeight = header.offsetHeight;

	if( header ) {
		document.addEventListener("scroll", function() {
			if( document.documentElement.scrollTop > topBarHeight ) {
				header.classList.add('fixed_top');
				headerPh.style.height = headerHeight+'px';
			} else {
				header.classList.remove('fixed_top');
				headerPh.style.height = 0;
			}
		});
	}

	// Megamenu opener
	var megaOpener = document.getElementById('btnMegamenu')
	var megaMenu = document.getElementById('vvMegamenu')
	if(megaOpener) {
		megaOpener.addEventListener('click', function() {
			this.classList.toggle('opened')
			megaMenu.classList.toggle('opened')
		})
	}

	// Carousels
	var recipeSliders = document.querySelectorAll('.vvCarousel');
    [].forEach.call(recipeSliders, function( slider, index, arr ) {

		// Get params
        var items_id = slider.parentNode.id;
        var items_xl = slider.getAttribute('data-itemsxl');
        var items_md = slider.getAttribute('data-itemsmd');
        var items_sm = slider.getAttribute('data-itemssm');
        var navigation = slider.getAttribute('data-nav');

		if(navigation == 'yes') {
			var swiper_nav = {
					nextEl: '#'+items_id+' .swiper-button-next',
					prevEl: '#'+items_id+' .swiper-button-prev',
				}
		} else {
			var swiper_nav = '';
		}

        var swiper = new Swiper(slider, {
            loop: false,
            spaceBetween: 20,

            // Responsive breakpoints
            breakpoints: {
            	// when window width is >= 320px
            	768: {
            		slidesPerView: items_sm,
            	},
            	// when window width is >= 480px
            	992: {
            		slidesPerView: items_md,
            	},
            	// when window width is >= 640px
            	1200: {
            		slidesPerView: items_xl,
            	}
            },
			// Navigation
			navigation: swiper_nav,
        });

    });

	// Related carousel
	var relatedCarousel = document.getElementById('vv-single-related')
	if( relatedCarousel ) {
		var slider = relatedCarousel.querySelector('.swiper')
		var items_xl = slider.getAttribute('data-itemsxl');
        var items_md = slider.getAttribute('data-itemsmd');
        var items_sm = slider.getAttribute('data-itemssm');

		var swiper = new Swiper(slider, {
            loop: false,
            spaceBetween: 10,

            // Responsive breakpoints
            breakpoints: {
            	// when window width is >= 320px
            	768: {
            		slidesPerView: items_sm,
            	},
            	// when window width is >= 480px
            	992: {
            		slidesPerView: items_md,
            	},
            	// when window width is >= 640px
            	1200: {
            		slidesPerView: items_xl,
            	}
            },
			// Navigation
			navigation: {
				nextEl: '#vv-single-related .swiper-button-next',
				prevEl: '#vv-single-related .swiper-button-prev',
			}
        });
	}

	// List items on click
	var listRecipes = document.querySelectorAll('.vv-recipe-list-item');
    [].forEach.call(listRecipes, function( item, index, arr ) {
		// Get the link
		var link = item.getAttribute('data-url');
		item.addEventListener('click', function() {
			location.href = link;
		})
	});


	// Toggles
	var faqToggles = document.querySelectorAll('.faq-toggles .rank-math-question');
	[].forEach.call(faqToggles, function( item, index, arr ) {

		item.addEventListener('click', function(event){

			event.preventDefault();
			var container = this.nextElementSibling;
			var $this = this;

			if ( !container.classList.contains('active') ) {
				$this.classList.add('active');
				container.classList.add('active');
				container.style.height = 'auto';
				var height = container.clientHeight + 'px';
				container.style.height = '0px';
				setTimeout(function () {
					container.style.height = height;
				}, 0);
			} else {
				container.style.height = '0px';
				container.addEventListener('transitionend', function () {
				container.classList.remove('active');
				$this.classList.remove('active');
			}, {
				once: true
			});
			}
			
		});
	});

})();

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	let expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
	  let c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
}